import { render } from "./OpenQuestion.vue?vue&type=template&id=97515672"
import script from "./OpenQuestion.vue?vue&type=script&lang=js"
export * from "./OpenQuestion.vue?vue&type=script&lang=js"

import "./OpenQuestion.vue?vue&type=style&index=0&id=97515672&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])